// @flow

import type {GetState, State} from 'redux/types';

export const DEVICE_TYPE_MOBILE: 'm' = 'm';
export const DEVICE_TYPE_TABLET: 't' = 't';
export const DEVICE_TYPE_DESKTOP: 'd' = 'd';

export type DeviceType =
  | typeof DEVICE_TYPE_MOBILE
  | typeof DEVICE_TYPE_TABLET
  | typeof DEVICE_TYPE_DESKTOP;

export const DISCOUNT_TYPE_TOUROPERATOR: 'tour operator' = 'tour operator';
export const DISCOUNT_TYPE_PRICECACHE: 'price cache' = 'price cache';

export type DiscountType =
  | typeof DISCOUNT_TYPE_TOUROPERATOR
  | typeof DISCOUNT_TYPE_PRICECACHE
  | null;

export type GtmGlobalEvent = {|
  global_environment: string,
  global_osname: string,
  global_devicetype: string,
  global_userid: string,
|};

export type GtmSearchEvent = {|
  search_destination_id: string,
  search_form: string,
  search_startdate?: string,
  search_enddate?: string,
  search_duration?: string,
  search_duration_min?: string,
  search_duration_max?: string,
  search_number_of_rooms: string,
  search_number_of_adults: string,
  search_number_of_children: string,
  search_child_ages?: string,
  search_room?: string,
  search_board?: string,
  search_baggage?: string,
  search_transfer?: string,
  search_departure_codes?: string,
  search_destination_codes?: string,
  search_seaview?: string,
  search_organizer_promotion?: string,
  search_flex_option?: string,
  search_safety_option?: string,
  search_special?: string,
|};

export type GtmEcommerceItem = {
  index: number,
  item_name: string,
  item_id: string,
  item_category?: string,
  item_category2?: string,
  item_category3?: string,
  item_category4?: string,
  item_category5?: string,
  item_brand: string,
  item_variant: string,
  item_upselling_type?: string,
  item_upselling_price?: number,
  item_altflight_price?: number,
  location_id?: string,
  discount?: number,
  item_discount_type?: DiscountType,
  currency: string,
  custom_coupon_value?: number,
  price: number,
  quantity: number,
};

export type EventHandler<Action, Event> = (
  action: Action,
  state: State
) => ?Event;

export type EventAction<Payload> = {|
  type: string,
  payload: Payload,
|};

export type EventActionCreator<Action, Payload> = (payload: Payload) => Action;

export type ThunkEventActionCreator = (
  ...args: Array<any>
) => (dispatch: Function, getState: GetState) => any;

export type Ecommerce = {
  items: GtmEcommerceItem[],
};

type GenericEvent = {
  event: string,
  event_action: string,
  non_interaction: boolean,
  checkout_step?: string,
};

export type EcommerceEvent = {
  ...GenericEvent,
  ecommerce: Ecommerce,
};

export type ErrorEvent = {
  ...GenericEvent,
  checkout_step: string,
  error_line?: string,
};

export type PsdAuthEvent = {
  ...GenericEvent,
  checkout_step: string,
};

export type CallToBookEvent = {
  ...GenericEvent,
  checkout_step: string,
};

export type CustomerIsTravelerEvent = {
  ...GenericEvent,
  customer_is_traveler: string,
};

export type UserVoucherShowEvent = {
  ...GenericEvent,
  users_voucher_code: string,
  users_voucher_value: string,
};

export type InsuranceConfirmEvent = {
  ...GenericEvent,
};

export type CheckoutEvent = GenericEvent;
